import { Entity } from "ecsy";
import { Obstacle, ObstacleType } from "../components/obstacle";
import { Player } from "../components/player";
import Disposer from "../components/disposer";
import { getPack } from "@/game/libs/engine/loader/asset-loader";
import Heart from "../components/heart";
import DisposableSystem from "@/game/libs/engine/root/disposable-system";
import { PlayerDirection } from "@/game/skifree/controller/Controller";

export default class ObstacleSystem extends DisposableSystem<any> {
  execute(delta: number, time: number) {
    var playerEntity: Entity = this.queries.player.results[0];
    var obstaclesQuery = this.queries.obstacle;
    var hearts: Array<Entity> = this.queries.heart.results;

    if (playerEntity) {
      var player = playerEntity.getMutableComponent(Player);
      obstaclesQuery.results.forEach((obstacleEntity: Entity) => {
        var obstacle = obstacleEntity.getComponent(Obstacle);
        var disposer = obstacleEntity.getComponent(Disposer);
        if (isHit(player, obstacle)) {
          this.handleHit(player, obstacleEntity);
          ObstacleSystem.updateHearts(player.lifeCount, hearts);
          if (player.lifeCount == 0) {
            (getPack().sound.obstacleDeath as Howl).play();
            player.endGame(this.createScore(player.y));
          }
        } else if (obstacle.y < player.y - 800) {
          disposer.dispose();
        }

        if (obstacle.y > player.y + 10) {
          obstacle.sprite.setParent(obstacle.over);
        } else {
          obstacle.sprite.setParent(obstacle.under);
        }
      });
    }
  }

  createScore(distance: number): number {
    return Math.floor(distance / 10);
  }

  handleHit(player: Player, obstacleEntity: Entity) {
    var obstacle = obstacleEntity.getComponent(Obstacle);
    switch (obstacle.type) {
      case ObstacleType.BAGGAGE_1:
        hitObstacle(player, obstacleEntity, getPack().sound
          .hit_baggage as Howl);
        break;
      case ObstacleType.BAGGAGE_2:
        hitObstacle(player, obstacleEntity, getPack().sound
          .hit_baggage as Howl);
        break;
      case ObstacleType.BAGGAGE_3:
        hitObstacle(player, obstacleEntity, getPack().sound
          .hit_baggage as Howl);
        break;
      case ObstacleType.RED_FLAG:
        hitObstacle(player, obstacleEntity, getPack().sound
          .hit_redFlag as Howl);
        break;
      case ObstacleType.SIGN:
        hitObstacle(player, obstacleEntity, getPack().sound.hit_MTV as Howl);
        break;
      case ObstacleType.TEXT_1:
        hitObstacle(player, obstacleEntity, getPack().sound.hit_youUp as Howl);
        break;
      case ObstacleType.TEXT_2:
        hitObstacle(player, obstacleEntity, getPack().sound
          .hit_checkMark as Howl);
        break;
      case ObstacleType.TREE:
        hitObstacle(player, obstacleEntity, getPack().sound.hit_tree as Howl);
        break;
    }
    player.lifeCount;
  }

  static updateHearts(lifeCount: number, hearts: Array<Entity>): void {
    hearts
      .filter(entity => entity.getComponent(Heart).id >= lifeCount)
      .forEach(entity => {
        var heart = entity.getComponent(Heart);
        heart.sprite.texture = heart.texOff;
      });
  }

  public dispose() {}
}

function hitObstacle(player: Player, obstacleEntity: Entity, sound: Howl) {
  sound.play();
  player.lifeCount--;
  player.sprite.play("EOTP_skier_crash", () => {
    var direction: PlayerDirection = player.direction;
    switch (direction) {
      case PlayerDirection.FACE_LEFT:
        player.sprite.loop("EOTP_skier_face_left");
        break;
      case PlayerDirection.FACE_SLIGHT_LEFT:
        player.sprite.loop("EOTP_skier_face_slight_left");
        break;
      case PlayerDirection.FACE_DOWN:
        player.sprite.loop("EOTP_skier_face_down");
        break;
      case PlayerDirection.FACE_SLIGHT_RIGHT:
        player.sprite.loop("EOTP_skier_face_slight_right");
        break;
      case PlayerDirection.FACE_RIGHT:
        player.sprite.loop("EOTP_skier_face_right");
        break;
    }
    player.isCrashed = false;
  });
  player.isCrashed = true;
  obstacleEntity.removeComponent(Obstacle);
}

function isHit(player: Player, obstacle: Obstacle): boolean {
  if (player.jumpingElapsed > 0) {
    return false;
  }
  var playerRadius = 13;

  var dx = player.x - obstacle.x;
  var dy = player.y - obstacle.y;
  var distance = Math.sqrt(dx * dx + dy * dy);

  return distance < playerRadius + obstacle.radius;
}

(ObstacleSystem as any).queries = {
  player: {
    components: [Player]
  },
  obstacle: {
    components: [Obstacle, Disposer]
  },
  heart: {
    components: [Heart]
  }
};
